import { render, staticRenderFns } from "./lkuBankaccountLazzy.vue?vue&type=template&id=003f195b&"
import script from "./lkuBankaccountLazzy.vue?vue&type=script&lang=js&"
export * from "./lkuBankaccountLazzy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports